import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateGreeting } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useUpdateGreeting({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const queryclient = useQueryClient();

  const Request = useMutation({
    mutationFn: updateGreeting,
    mutationKey: ['updateGreeting'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries(['greetingList']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
